'use strict';

var MITS = require('../mits');

var WidgetUtils = require('./WidgetUtils');
WidgetUtils.requireStylesheet('MITS.Widgets.ValuesList');

var ValuesList = function (container, inputName, values, options) {
    this.initialize(container, inputName, values, options);
};

ValuesList._instanceCount = 1;
ValuesList.prototype = {
    _inputName: 'value', // the name attribute of the input elements created

    _divIdPrefix: 'valuesListDiv_',
    _container: null,

    // stuff from options
    _textBoxIsInput: false,  // should the text box also be an input bound to the same name
    _firstValueInTextBox: false,  // should the first value in the list be populated into the text box instead of the list div  
    _stack: false, // do new values go on the top or the bottom?

    _addValueMessage: 'Add a value: ',
    _noValuesMessage: 'No values set',
    _trimValue: false,  // should the value in the box be trimmed before adding it to the list

    _valueValidator: null,
    _hasValuesListener: null,
    _addValueListener: null,
    _removeValueListener: null,
    _inputListener: null,  // added to the onkeyup of the input box, takes the current value as a parameter

    _valueTableWidth: 270, // much smaller than this and the plus button will wrap around on ipad
    _valueTdWidth: 236,
    _noValuesTdWidth: 260,
    _tabindex: 1,   // of the add values text box on the page. For some reason starting at 0 makes it not work.

    /**
     * @param containerID - The ID of an empty DOM element.
     * @param inputName - the name attribute of the input elements that this will create
     * @param values -  the values to list
     */
    /* eslint-disable complexity */
    initialize: function (containerID, inputName, values, options) {

        if (typeof containerID !== 'string'){
            console.error('For the ValuesList widget, expecting the input parameter \'container\' to be of type string, but was type \'' + (typeof containerID) + '\'.');
        }

        //Give this instance a unique prefix it can use for its items so they don't clash
        //with IDs for items from other CheckableItemsList instances on the same page.
        this._divIdPrefix = this._divIdPrefix + ValuesList._instanceCount++ + '_';

        jQuery('#' + containerID).empty();
        this._container = document.getElementById(containerID);

        this._inputName = inputName;

        if (!options) {
            options = {};
        }
        if (options.textBoxIsInput) {
            this._textBoxIsInput = options.textBoxIsInput;
        }
        if (options.firstValueInTextBox) {
            this._firstValueInTextBox = options.firstValueInTextBox;
        }
        if (options.stack) {
            this._stack = options.stack;
        }

        if (options.addValueMessage) {
            this._addValueMessage = options.addValueMessage;
        }
        if (options.noValuesMessage) {
            this._noValuesMessage = options.noValuesMessage;
        }
        if (options.trimValue) {
            this._trimValue = options.trimValue;
        }

        if (options.valueValidator) {
            this._valueValidator = options.valueValidator;
        }
        if (options.hasValuesListener) {
            this._hasValuesListener = options.hasValuesListener;
        }
        if (options.addValueListener) {
            this._addValueListener = options.addValueListener;
        }
        if (options.removeValueListener) {
            this._removeValueListener = options.removeValueListener;
        }
        if (options.inputListener) {
            this._inputListener = options.inputListener;
        }

        if (options.valueTableWidth) {
            this._valueTableWidth = options.valueTableWidth;
        }
        if (options.valueTdWidth) {
            this._valueTdWidth = options.valueTdWidth;
        }
        if (options.noValuesTdWidth) {
            this._noValuesTdWidth = options.noValuesTdWidth;
        }

        if (options.tabindex) {
            this._tabindex = options.tabindex;
        }

        if (values == null) {
            values = [];
        }

        this._container.appendChild(this._generateAddValueDiv());

        if (this._firstValueInTextBox && values.length > 0) {
            document.getElementById(this._divIdPrefix + '_addValueInput').value = values[0];
            if (values.length > 1) {
                values = values.slice(1);
            } else {
                values = [];
            }
        }

        this._container.appendChild(this._generateValuesTable(values));

        this._setRowColoringOnValuesTable();

    },
    /* eslint-enable complexity */

    /* get a list of the values, in the order they've been specified
     * includes the text box if textBoxIsInput */
    getValues: function () {
        var valuesArray = new Array();
        var inputs = this._container.getElementsByTagName('input');
        for (var i = 0; i < inputs.length; i++) {
            var input = inputs[i];
            if (input.value !== '') {
                valuesArray.push(input.value);
            }
        }
        return valuesArray;
    },

    hasValueInTextBox: function () {
        return this._textBoxIsInput && document.getElementById(this._divIdPrefix + '_addValueInput').value !== '';
    },

    getTextBox: function () {
        return document.getElementById(this._divIdPrefix + '_addValueInput');
    },

    //text box and add button
    _generateAddValueDiv: function () {
        var addValueDiv = document.createElement('div');
        addValueDiv.className = 'nowrap';
        addValueDiv.style['width'] = this._valueTableWidth + 'px';
        addValueDiv.style['position'] = 'relative'; // crucial for making absolute position of valuesListAddButton work

        addValueDiv.appendChild(document.createTextNode(this._addValueMessage));

        //create a dummy empty input so that spring knows it's binding a list and the value in the other box is a single value even if it contains a comma
        var dummyInput = document.createElement('input');
        dummyInput.setAttribute('type', 'hidden');
        dummyInput.setAttribute('name', this._inputName);
        dummyInput.setAttribute('value', '');
        addValueDiv.appendChild(dummyInput);

        var textInput = document.createElement('input');
        textInput.setAttribute('tabindex', this._tabindex + 1);
        textInput.setAttribute('type', 'text');
        if (this._textBoxIsInput) {
            textInput.setAttribute('name', this._inputName);
        }

        textInput.setAttribute('id', this._divIdPrefix + '_addValueInput');
        textInput.setAttribute('value', '');
        textInput.onkeypress = function (event) {
            if (MITS.Util.wasThatTheEnterKey(event)) {
                this._addValue();
                return false;
            }
            return true;
        }.bind(this);

        textInput.onkeyup = function (textInput) {
            if (this._inputListener) {
                this._inputListener(textInput.value);
            }
        }.bind(this, textInput);

        addValueDiv.appendChild(textInput);

        var addButton = document.createElement('div');
        addButton.setAttribute('id', this._divIdPrefix + '_addValueLink');
        addButton.className = 'valuesListAddButton';
        addButton.onclick = function () {
            this._addValue();
            return false;
        }.bind(this);

        addValueDiv.appendChild(addButton);

        return addValueDiv;
    },


    _addValue: function () {
        var valueInput = document.getElementById(this._divIdPrefix + '_addValueInput');

        if (this._trimValue) {
            valueInput.value = valueInput.value.trim();
        }

        if (valueInput.value === ''){
            return false;
        }

        if (this._valueValidator && !this._valueValidator(valueInput.value)) {
            return false;
        }

        var tr = this._generateValueRow(valueInput.value);

        var table = document.getElementById(this._divIdPrefix + '_valuesTable');

        if (this._stack) {
            table.insertBefore(tr, table.firstChild);
        } else {
            table.appendChild(tr);
        }


        this._updateHasValuesStatus(table, true);
        this._setRowColoringOnValuesTable();

        valueInput.value = '';
        if (this._addValueListener) {
            this._addValueListener();
        }
    },


    _removeValue: function (removeButton) {
        var row = removeButton.parentNode.parentNode;
        row.parentNode.removeChild(row);
        this._setRowColoringOnValuesTable();

        var table = document.getElementById(this._divIdPrefix + '_valuesTable');
        if (table.getElementsByTagName('tr').length === 0) {
            this._updateHasValuesStatus(table, false);
        }
        if (this._removeValueListener) {
            this._removeValueListener();
        }
    },


    _updateHasValuesStatus: function (table, hasValues) {
        if (hasValues) {
            var noValuesRow = document.getElementById(this._divIdPrefix + '_noValuesRow');
            if (noValuesRow) {
                noValuesRow.parentNode.removeChild(noValuesRow);
            }
        } else {
            table.appendChild(this._generateNoValuesRow());
        }
        if (this._hasValuesListener) {
            this._hasValuesListener(hasValues);
        }
    },

    /*
     * the little table that shows values for a particular item
     */
    _generateValuesTable: function (values) {
        var div = document.createElement('div');
        div.style['marginTop'] = '15px';

        // add a table even if it's empty so it can have stuff added to it later
        var table = document.createElement('table');
        table.style['border'] = '1px solid #c0c0c0';
        table.style['tableLayout'] = 'fixed'; // make IE8 honor maxWidth
        table.style['width'] = this._valueTableWidth + 'px';
        table.style['maxWidth'] = this._valueTableWidth + 'px';

        table.id = this._divIdPrefix + '_valuesTable';
        table.setAttribute('cellspacing', '0');
        table.className = 'noBordersTable slimLineTable';

        if (values.length > 0) {
            for (var i = 0; i < values.length; i++) {
                table.appendChild(this._generateValueRow(values[i]));
            }
        } else {
            table.appendChild(this._generateNoValuesRow());
        }

        div.appendChild(table);
        return div;
    },

    /*
     * Generate one of the rows of the little table that shows values for a particular item
     */
    _generateValueRow: function (value) {
        var tr = document.createElement('tr');
        var textTd = document.createElement('td');
        textTd.style['width'] = this._valueTdWidth + 'px';
        textTd.style['maxWidth'] = this._valueTdWidth + 'px'; // can't deal with dashes when accessing styles via js so use maxWidth insted of max-width
        textTd.style['overflow'] = 'hidden';

        var hiddenInput = document.createElement('input');
        hiddenInput.setAttribute('type', 'hidden');
        hiddenInput.setAttribute('name', this._inputName);
        hiddenInput.setAttribute('value', value);
        textTd.appendChild(hiddenInput);
        textTd.appendChild(document.createTextNode(value.replace(/\s/g, '\u00a0'))); // &nbsp; would go in literally; the actual spaces get smushed.  unicode to the rescue!
        textTd.title = value;

        tr.appendChild(textTd);

        var removeButtonTd = document.createElement('td');
        removeButtonTd.align = 'right';
        removeButtonTd.style['padding'] = '4px';

        var removeButton = document.createElement('div');
        removeButton.className = 'valuesListDeleteButton';
        removeButton.onclick = function () {
            this._removeValue(removeButton);
            return false;
        }.bind(this);

        removeButtonTd.appendChild(removeButton);
        tr.appendChild(removeButtonTd);

        return tr;
    },

    _generateNoValuesRow: function () {
        var tr = document.createElement('tr');
        tr.setAttribute('id', this._divIdPrefix + '_noValuesRow');
        var td = document.createElement('td');
        td.setAttribute('colspan', '2');
        td.style['width'] = this._noValuesTdWidth + 'px';

        var span = document.createElement('span');
        span.className = 'note disabledText';
        span.appendChild(document.createTextNode(this._noValuesMessage));

        td.appendChild(span);
        tr.appendChild(td);
        return tr;
    },

    /*
     * Modify styles on DOM
     */

    _setRowColoringOnValuesTable: function () {
        var rows = document.getElementById(this._divIdPrefix + '_valuesTable').getElementsByTagName('tr');
        for (var i = 0; i < rows.length; i++) {
            if (rows[i].id !== this._divIdPrefix + '_noValuesRow') {
                var $row = jQuery(rows[i]);
                $row.removeClass((i % 2 === 0 ? 'evenRow' : 'oddRow'  ));
                $row.addClass((i % 2 === 0 ? 'oddRow' : 'evenRow' ));
            }
        }
    }
};

module.exports = ValuesList;


//////////////////
// WEBPACK FOOTER
// ./mits/Widgets/ValuesList.js
// module id = 40
// module chunks = 0